import { ReactNode } from 'react';
import { Link } from 'react-router-dom';

type searchObject = {
    [key: string]: string;
};

type UseByzzerConditionalLinkParameter = {
    path: string;
    search?: searchObject | string;
    state?: any; // defined as any because type of state in "LinkProps" is any
    condition?: boolean;
    content?: ReactNode;
};

export const UseByzzerConditionalLink = ({ path, search, state, condition = true, content }: UseByzzerConditionalLinkParameter) => {
    const searchParam = new URLSearchParams(search).toString();
    return condition ? (
        <Link to={{ pathname: path, search: searchParam ?? '' }} state={state ?? {}}>
            {content}
        </Link>
    ) : (
        <>{content}</>
    );
};

export default UseByzzerConditionalLink;

UseByzzerConditionalLink.displayName = 'UseByzzerConditionalLink';
